export const getDefaultOptions = (theme: any, locale: any, maintainAspectRation: boolean, calcAverage: any, xunit: any, dimension: string) => {
    const a = {
        type: 'line',
        borderColor: theme.colors.backgroundInversePrimary,
        borderDash: [6, 6],
        borderDashOffset: 0,
        borderWidth: 1,
        label: {
            display: true,
            content: (ctx) => `Ø ${calcAverage().toFixed(calcAverage() > 100 ? 0 : 1 )} ${dimension}`,
            position: "start",
            color: theme.colors.contentInversePrimary,
            backgroundColor: theme.colors.backgroundInversePrimary,
            font: {
                weight: 'normal'
            },
        },

        scaleID: 'y',
        value: calcAverage(),
    }
    const tmp: any =
    {
        responsive: true,
        maintainAspectRatio: maintainAspectRation,
        plugins: {

            title: {
                display: false,
                text: 'hallo '
            },
            legend: {
                display: true,
            },
            annotation: {
                //drawTime: 'afterDatasetsDraw',
                annotations: {
                    a
                }
            }
        },
        scales: {
            y: {
                alignToPixels: true,
                grid: {
                    display: true,
                    drawBorder: false,
                    drawOnChartArea: true,
                    drawTicks: false,
                },
            },
            x: {
                adapters: {
                    date: { locale: locale }
                },
                type: 'time',
                time: {
                    unit: xunit,
                    stepSize: 1,
                    /* displayFormats: {
                       minute: 'HH:mm'
                     }*/
                },
                ticks: {
                    display: true,
                    //autoSkip: true,
                    source: "data",
                    maxRotation: 0,
                    //maxTicksLimit: 5,
                    padding: 4,
                    /* major: {
                       enabled: true
                     },*/
                },
                grid: {
                    display: false,
                    drawBorder: false,
                    drawOnChartArea: false,
                    drawTicks: false,
                }
            }
        }

    };
    return tmp;
}